import type { IconType } from "react-icons";
import { FiMail, FiHeadphones, FiFolder, FiUserCheck, FiTrendingUp, FiPhoneCall, FiBarChart2, FiPieChart, FiCreditCard, FiCpu } from "react-icons/fi";
import serviceRequestImg from "../../assets/images/agents/service-request-agent.png";
import customerServiceImg from "../../assets/images/agents/customer-service-agent.png";
import officeManagerImg from "../../assets/images/agents/office-manager-agent.png";
import accountManagerImg from "../../assets/images/agents/account-manager-agent.png";
import salesImg from "../../assets/images/agents/sales-agent.png";
import voiceImg from "../../assets/images/agents/voice-agent.png";
import rateQuotingImg from "../../assets/images/agents/rate-quoting-agent.png";
import accountingImg from "../../assets/images/agents/accounting-agent.png";
import billingImg from "../../assets/images/agents/billing-agent.png";
import hermesImg from "../../assets/images/agents/hermes-agent.png";
// Head-and-shoulders cutouts (transparent background) for small avatar tiles,
// cut from the scene photos above so the face reads at 20–30px.
import serviceRequestAvatar from "../../assets/images/agents/avatars/service-request-agent.png";
import customerServiceAvatar from "../../assets/images/agents/avatars/customer-service-agent.png";
import officeManagerAvatar from "../../assets/images/agents/avatars/office-manager-agent.png";
import accountManagerAvatar from "../../assets/images/agents/avatars/account-manager-agent.png";
import salesAvatar from "../../assets/images/agents/avatars/sales-agent.png";
import voiceAvatar from "../../assets/images/agents/avatars/voice-agent.png";
import rateQuotingAvatar from "../../assets/images/agents/avatars/rate-quoting-agent.png";

export interface DefaultAgentVisual {
    /** Full scene photo — Digital Workforce cards and other large surfaces. */
    image: string;
    /** Transparent cutout — small avatars (sidebar, chat bar, Command Center). */
    avatar: string;
    icon: IconType;
}

/** Keyed by lowercased default-agent display name (suffix "-{userId}" already stripped). */
const DEFAULT_AGENT_VISUALS: Record<string, DefaultAgentVisual> = {
    "service request agent": { image: serviceRequestImg, avatar: serviceRequestAvatar, icon: FiMail },
    "customer service agent": { image: customerServiceImg, avatar: customerServiceAvatar, icon: FiHeadphones },
    "office manager agent": { image: officeManagerImg, avatar: officeManagerAvatar, icon: FiFolder },
    "account manager agent": { image: accountManagerImg, avatar: accountManagerAvatar, icon: FiUserCheck },
    "sales agent": { image: salesImg, avatar: salesAvatar, icon: FiTrendingUp },
    "voice agent": { image: voiceImg, avatar: voiceAvatar, icon: FiPhoneCall },
    "rate quoting agent": { image: rateQuotingImg, avatar: rateQuotingAvatar, icon: FiBarChart2 },
    "hermes agent": { image: hermesImg, avatar: hermesImg, icon: FiCpu },
    // Opportunity has no confirmed photo yet — falls back to the plain text card.
};

export function getDefaultAgentVisual(name: string): DefaultAgentVisual | undefined {
    return DEFAULT_AGENT_VISUALS[name.trim().toLowerCase()];
}

/** Agents not yet available in the backend — rendered as disabled "Coming Soon" cards. */
export interface ComingSoonAgent {
    id: string;
    name: string;
    description: string;
    image: string;
    icon: IconType;
}

export const COMING_SOON_AGENTS: ComingSoonAgent[] = [
    {
        id: "__coming-soon-accounting-agent",
        name: "Accounting Agent",
        description: "Reconciles commissions, carrier statements, and month-end close.",
        image: accountingImg,
        icon: FiPieChart,
    },
    {
        id: "__coming-soon-billing-agent",
        name: "Billing Agent",
        description: "Manages payment plans, late payments, cancellations, and reinstatements.",
        image: billingImg,
        icon: FiCreditCard,
    },
];
